module.exports = __webpack_public_path__ + "img/px.b1fe6c65.png";